import { useHistory } from 'react-router-dom'
import { GetStorageListPropsSchemaType } from '../schema/storage.items-filter.schema'
import { GetStorageListOrder, GetStorageListOrderDirection } from '../schema/storage.items-filter.schema'

export const getDefaultStorageItemsFilter = (): GetStorageListPropsSchemaType => {
  const history = useHistory()
  const searchParams = new URLSearchParams(history.location.search)

  const by = searchParams.get('order.by') as keyof typeof GetStorageListOrder
  const direction = searchParams.get('order.direction') as keyof typeof GetStorageListOrderDirection

  return {
    filter: {
      name: searchParams.get('filter.name') || undefined,
      date: {
        start: searchParams.get('filter.date.start') || undefined,
        end: searchParams.get('filter.date.end') || undefined
      }
    },
    page: Number(searchParams.get('page') || 1),
    limit: Number(searchParams.get('limit') || 10),
    order: {
      by: GetStorageListOrder[by || 'DATE'],
      direction: GetStorageListOrderDirection[direction || 'ASC']
    }
  }
}
